import CheckmarkIconButton from '@c/icons/buttons/CheckmarkButton';

interface RadioProps {
  label: string;
  selected?: boolean;
  disabled?: boolean;
  onChange: () => void;
  error?: boolean;
  labelClassName?: string;
}

const Checkbox = ({
  label,
  selected,
  disabled = false,
  onChange,
  error,
  labelClassName,
}: RadioProps) => {
  return (
    <div
      className={`flex items-center ${error ? 'border-2 border-red-500' : ''}`}
    >
      <CheckmarkIconButton
        checked={selected}
        disabled={disabled}
        label={label}
        labelClassName={labelClassName}
        onClick={() => onChange()}
      />
    </div>
  );
};

export default Checkbox;
